<template>
  <div>
    <slot name="button" :openPanel="openPanel"> </slot>
    <b-sidebar
      id="sidebar-contract"
      width="450px"
      backdrop-variant="dark"
      backdrop
      right
      shadow
      v-model="visible"
      @hidden="resetUrl"
    >
      <b-container fluid class="container-sidebar">
        <b-row class="panel">
          <b-col>
            <b-overlay :show="loading">
              <b-row class="item-dados">
                <b-col class="sumary">
                  <b-row class="mb-3">
                    <!-- Code -->
                    <b-col cols="4">
                      <p class="label-campo">{{ $t('seller.recurrence_subscriptions.right_preview.text_1789') }}</p>
                      <p class="dados-campo">{{ contract.id }}</p>
                    </b-col>
                    <!-- Status -->
                    <b-col cols="4">
                      <p class="label-campo">{{ $t('seller.recurrence_subscriptions.right_preview.text_1790') }}</p>
                      <p
                        class="dados-campo"
                        :class="getStatus(contract.status).class"
                      >
                        {{ getStatus(contract.status).text }}
                      </p>
                    </b-col>
                    <!-- Beginning -->
                    <b-col cols="4">
                      <p class="label-campo">{{ $t('seller.recurrence_subscriptions.right_preview.text_1791') }}</p>
                      <p class="dados-campo" v-if="contract.start_date">
                        {{ contract.start_date | date }}
                      </p>
                    </b-col>
                  </b-row>
                  <!-- Next Expiration -->
                  <b-row v-if="validateNextExpiration()">
                    <b-col cols="6">
                      <p class="label-campo">{{ $t('seller.recurrence_subscriptions.right_preview.text_1792') }}</p>
                      <p v-if="contract.method === 'BOLETO' &&
                        (contract.history &&
                        Array.isArray(contract.history) &&
                        contract.history[contract.history.length - 1] &&
                        contract.history[contract.history.length - 1].boleto_expiration_date)"
                        class="dados-campo"
                      >
                        {{ contract.history[contract.history.length - 1].boleto_expiration_date | date }}
                      </p>
                      <p class="dados-campo" v-else>
                        {{ contract.current_period_end | date }}
                      </p>
                    </b-col>
                  </b-row>
                  <b-row v-if="contract.status == 'canceled'">
                    <b-col cols="6">
                      <p class="label-campo">{{ $t('views.seller.sales.text_1348') }}</p>                     
                      <p class="dados-campo">
                        {{ contract.canceled_at | date }}
                      </p>                      
                      <div v-if="contract.canceled_user && contract.canceled_user.name && contract.canceled_reason !== 'FINANCE_SOLICITATION'">
                        <p class="label-campo mt-2">{{ $t('seller.recurrence_subscriptions.right_preview.text_264') }}</p>
                        <p class="dados-campo">
                          {{ contract.canceled_user.name }}
                        </p>
                      </div>      
                    </b-col>
                    <b-col cols="6">
                      <p class="label-campo">{{ $t('seller.recurrence_subscriptions.right_preview.text_265') }}</p>                     
                      <p class="dados-campo">
                        {{ contract.canceled_reason == 'USER_SOLICITATION' ? $t('seller.recurrence_subscriptions.right_preview.text_266') : contract.canceled_reason == 'FINANCE_SOLICITATION' ? $t('seller.recurrence_subscriptions.right_preview.text_268') : $t('seller.recurrence_subscriptions.right_preview.text_267') }}
                      </p>
                    </b-col>
                  </b-row>
                  <!-- Method -->
                  <b-col cols="5" class="mt-2">
                    <p class="label-campo">{{ $t('seller.recurrence_subscriptions.right_preview.text_1793') }}</p>
                    <p class="dados-campo">
                      {{
                        contract.history && contract.history.length
                          ? getMethod(contract.history[0].method)
                          : $t('seller.recurrence_subscriptions.right_preview.text_1811')
                      }}
                    </p>
                  </b-col>
                  <!-- Installments -->
                  <b-col cols="5" class="mt-2">
                    <p class="label-campo">{{ $t('seller.recurrence_subscriptions.right_preview.text_3014') }}</p>
                    <p class="dados-campo">
                      {{ paidTransaction }}/{{ checkHasCharges() }}
                    </p>
                  </b-col>
                  <template v-if="isHeaven && contract.history && contract.history.length">
                    <!-- Local Currency -->
                    <b-col v-if="contract.history[0].local_currency != undefined" cols="12" class="mt-4">
                      <p class="label-campo mr-2">{{ $t('seller.recurrence_subscriptions.right_preview.text_253') }}</p>
                      <span>{{ contract.history[0].local_currency.name }}</span>
                    </b-col>
                    <!-- Base Currency -->
                    <b-col v-if="contract.history[0].base_currency != undefined" cols="12" class="mt-4">
                      <p class="mr-2 label-campo">{{ $t('seller.recurrence_subscriptions.right_preview.text_254') }}</p>
                      <section class="d-flex align-items-center">
                        <div class="chip" :style="setColors(contract.history[0].base_currency.currency)">
                          {{ contract.history[0].base_currency ? contract.history[0].base_currency.currency_symbol : "R$" }}
                        </div>
                        <span> {{ contract.history[0].base_currency.currency }}</span>
                      </section>
                    </b-col>
                    <!-- Country -->
                    <b-col v-if="contract.history[0].country != undefined" cols="12" class="mt-4">
                      <p class="mr-2 label-campo">{{ $t('seller.recurrence_subscriptions.right_preview.text_255') }}</p>
                      <section class="d-flex align-items-center">
                        <img class="mr-2" style="height: 30px;" :src="require(`@/assets/locales/flag-${contract.history[0].country.country_code}.png`)" />
                        <span> {{ contract.history[0].country.name }}</span>
                      </section>
                    </b-col>
                  </template>
                </b-col>
              </b-row>

              <!-- Product -->
              <b-row class="item-dados">
                <b-col>
                  <h5 class="titulo-item" :class="{'heaven': isHeaven}">{{ $t('seller.recurrence_subscriptions.right_preview.text_1794') }}</h5>

                  <b-col cols="12">
                    <div class="product-main">
                      <div class="img-product">
                        <img
                          :src="contract.contract.live.product.images[0].path"
                          v-if="
                            !loading &&
                            contract.contract.live.product &&
                            contract.contract.live.product.images.length
                          "
                        />
                      </div>
                      <div
                        class="name-product"
                        v-if="!loading && contract.contract.live.product"
                      >
                        <span
                          >{{ $t('seller.recurrence_subscriptions.right_preview.text_1794') }}: #{{
                            contract.contract.live.product.id
                          }}</span
                        >
                        <p>{{ contract.contract.live.product.name }}</p>
                        <p class="hash" v-if="contract.contract.offer">Código da Oferta: {{ contract.contract.offer.hash }}</p>
                      </div>
                    </div>
                  </b-col>
                </b-col>
              </b-row>

              <!-- Affiliate -->
              <b-row v-if="contract.affiliate" class="item-dados">
                <b-col>
                  <h5 class="titulo-item" :class="{'heaven': isHeaven}">{{ $t('seller.recurrence_subscriptions.right_preview.text_1795') }}</h5>
                  <p class="label-campo">
                    <span class="title-item">{{ $t('seller.recurrence_subscriptions.right_preview.text_1796') }}</span>
                    <span>{{ contract.affiliate.name }}</span>
                  </p>
                  <p class="label-campo">
                    <span class="title-item">{{ $t('seller.recurrence_subscriptions.right_preview.text_1797') }}</span>
                    <span>{{ contract.affiliate.email }}</span>
                  </p>
                </b-col>
              </b-row>

              <!-- Client -->
              <b-row class="item-dados">
                <b-col v-if="contract.client">
                  <h5 class="titulo-item" :class="{'heaven': isHeaven}">{{ $t('seller.recurrence_subscriptions.right_preview.text_1798') }}</h5>
                  <p class="label-campo">
                    <span class="title-item">{{ $t('seller.recurrence_subscriptions.right_preview.text_1796') }}</span>
                    <span>{{ contract.client.name }}</span>
                  </p>
                  <p class="label-campo" v-if="isSeller">
                    <span class="title-item">{{ $t('seller.recurrence_subscriptions.right_preview.text_1797') }}</span>
                    <span>{{ contract.client.email }}</span>
                  </p>
                  <p class="label-campo" v-if="isSeller">
                    <span class="title-item">{{ contract.client.document_type ? contract.client.document_type : $t('seller.recurrence_subscriptions.right_preview.text_263')}}</span>
                    <span>{{ contract.client.document }}</span>
                  </p>
                  <p class="label-campo" v-if="isSeller">
                    <span class="title-item">{{ $t('seller.recurrence_subscriptions.right_preview.text_1800') }}</span>

                    <a
                      :href="formatTel(contract.client.cellphone)"
                      target="_blank"
                      class="whats-cliente"
                      >{{ contract.client.cellphone
                      }}<font-awesome-icon :icon="['fab', 'whatsapp']"
                    /></a>
                  </p>
                </b-col>
              </b-row>

              <!-- Transactions -->
              <b-row class="item-dados">
                <b-col>
                  <h5
                    v-b-toggle.collapse-2
                    class="titulo-item titulo-arrow"
                    :class="{ 'ativo': collapse, 'heaven': isHeaven }"
                    @click="collapse = !collapse"
                  >
                    {{ $t('seller.recurrence_subscriptions.right_preview.text_1801') }}
                    <img src="@/assets/img/icons/arrow-fill.svg" alt="" />
                  </h5>

                  <b-collapse id="collapse-2" data-anima="top">
                    <b-row class="mt-3 mb-1">
                      <div class="label-campo"></div>
                      <b-col cols="2" class="titulo-collapse label-campo">
                        {{ $t('seller.recurrence_subscriptions.right_preview.text_1802') }}
                      </b-col>

                      <b-col cols="3" class="titulo-collapse label-campo">
                        <span v-if="contract.method === 'BOLETO'">
                          {{ $t('seller.recurrence_subscriptions.right_preview.text_1813') }}
                        </span>
                        <span v-else>
                          {{ $t('seller.recurrence_subscriptions.right_preview.text_1803') }}
                        </span>
                      </b-col>

                      <b-col cols="4" class="titulo-collapse label-campo">
                        {{ $t('seller.recurrence_subscriptions.right_preview.text_1804') }}
                      </b-col>

                      <b-col cols="3" class="titulo-collapse label-campo">
                        {{ $t('seller.recurrence_subscriptions.right_preview.text_1805') }}
                      </b-col>
                    </b-row>

                    <!-- Historic -->
                    <div v-if="contract.history && contract.history.length">
                      <div
                        v-for="item in contract.history"
                        :key="item.id"
                        class="history-item"
                        :class="getStatus_sales(item.status).class"
                        v-b-tooltip="{
                          title: getStatus_sales(item.status).text,
                          placement: 'right',
                        }"
                      >
                        <b-row>
                          <b-col
                            cols="2"
                            class="label-campo titulo-collapse mt-1"
                          >
                            <span>{{ item.id }} </span></b-col
                          >

                          <b-col cols="3" class="label-campo titulo-collapse">
                            <span v-if="contract.method === 'BOLETO'">{{ item.boleto_expiration_date | date }}</span>
                            <span v-else > {{ item.created_at | date }}</span>
                          </b-col>

                          <b-col cols="4" class="label-campo titulo-collapse">
                            <span v-if="item.paid_at">
                              {{ item.paid_at | date }}</span
                            >
                            <span v-else>-</span>
                          </b-col>

                          <b-col cols="3" class="label-campo titulo-collapse">
                            <span v-if="item.balance">
                              {{ contract.history[0].base_currency ?
                                contract.history[0].base_currency.currency_symbol : "R$" }}
                              {{ formatMoney(item.balance) }}
                            </span>
                            <a
                              :href="item.boleto_url"
                              target="_blank"
                              v-if="
                                item.method == 'BOLETO' &&
                                item.status != 'paid' &&
                                item.status != 'refunded'
                              "
                              >{{ $t('seller.recurrence_subscriptions.right_preview.text_1806') }}</a
                            >

                            <span
                              v-if="
                                !item.balance &&
                                item.method != 'BOLETO' &&
                                item.status != 'paid'
                              "
                            >
                              {{ contract.history[0].base_currency ?
                                contract.history[0].base_currency.currency_symbol : "R$" }} 0,00
                            </span>
                            <span v-else>
                              {{ contract.history[0].base_currency ?
                                contract.history[0].base_currency.currency_symbol : "R$" }} {{ formatMoney(item.amount) }}
                            </span>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                    <div v-else>
                      <p class="sem-historico">{{ $t('seller.recurrence_subscriptions.right_preview.text_247') }}</p>
                    </div>
                  </b-collapse>
                </b-col>
              </b-row>

              <!-- Options -->
              <b-row class="item-dados" v-if="!$store.getters.setPanel || canEditContract">
                <b-col>
                  <h5 class="titulo-item" :class="{'heaven': isHeaven}">{{ $t('seller.recurrence_subscriptions.right_preview.text_1807') }}</h5>
                  <div class="btn-flex">
                    <BaseConfirmDialog
                      v-if="!$store.getters.setPanel || ($store.getters.setPanel && (canDeleteContract ||canEditContract))"
                      class="d-inline-block"
                      @confirmed="cancelContract"
                      id="btn-cancela-contrato"
                    >
                      <template v-slot:button="{ openModal }">
                        <BaseButton
                          variant="danger"
                          :outline="true"
                          :disabled="
                            contract.status == 'canceled' ||
                            contract.status == 'CANCELED' ||
                            contract.status == 'PROCESSING' ||
                            contract.status == 'processing' ||
                            is_btn_disable
                          "
                          @click="openModal"
                        >
                          {{
                            contract.status == "PROCESSING" ||
                            contract.status == "processing"
                              ? $t('seller.recurrence_subscriptions.right_preview.text_1808')
                              : $t('seller.recurrence_subscriptions.right_preview.text_1809')
                          }}
                        </BaseButton>
                      </template>
                    </BaseConfirmDialog>

                    <b-tooltip
                      v-if="
                        contract.status == 'canceled' ||
                        contract.status == 'CANCELED'
                      "
                      target="btn-cancela-contrato"
                      :title="$t('seller.recurrence_subscriptions.right_preview.text_1810')"
                    />

                    <Affiliation
                      v-if="
                        (contract.seller_id == userID &&
                          !contract.affiliate &&
                          contract.status == 'ACTIVE') ||
                        contract.status == 'paid'
                      "
                      :product_id="contract.contract.product_id"
                      from="contract"
                      @close="fetchContract"
                      class="d-inline-block"
                    >
                      <template v-slot:button="{ openModal }">
                        <BaseButton
                          v-if="canEditContract"
                          variant="info"
                          :outline="true"
                          @click="openModal(contract_id)"
                          >{{ $t('seller.recurrence_subscriptions.right_preview.text_248') }}</BaseButton
                        >
                      </template>
                    </Affiliation>

                    <Subscription
                      v-if="
                        contract.seller_id == userID &&
                        contract.status == 'ACTIVE'
                      "
                      @close="fetchContract"
                      class="d-inline-block"
                    >
                      <template v-slot:button="{ openModal }">
                        <BaseButton
                          v-if="!$store.getters.setPanel || ($store.getters.setPanel && canEditContract)"
                          variant="black"
                          @click="openModal(contract_id)"
                          >{{ $t('seller.recurrence_subscriptions.right_preview.text_249') }}</BaseButton
                        >
                      </template>
                    </Subscription>
                    <!-- Atualizar Assinatura -->
                    <div>
                      <BaseButton
                       v-if="!$store.getters.setPanel || ($store.getters.setPanel && canEditContract) || hasSubscriptionId"
                       variant="primary"
                       :class="{'heaven': isHeaven}"
                       @click="openSalesPage()"
                       :disabled="viewSalesUpdate"
                      >
                        {{ $t('seller.recurrence_subscriptions.right_preview.text_250') }}
                      </BaseButton>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-overlay>
          </b-col>
        </b-row>
      </b-container>
    </b-sidebar>
  </div>
</template>
<script>
import RecurrenceSubscriptionService from "@/services/resources/RecurrenceSubscriptionService";
import Affiliation from "@/components/shared/modals/Affiliation";
import Subscription from "./modals/Subscription";
import moment from "moment";
import Money from "@/mixins/money";
import { EventBus } from "@/main.js";
import Cookies from "js-cookie";

const service = RecurrenceSubscriptionService.build();

export default {
  name: "DetalhesContrato",
  components: { Affiliation, Subscription },
  props: {
    updateQueryParams: {
      type: Function,
      default: () => ({}),
    },
  },
  mixins: [Money],
  data() {
    return {
      loading: true,
      collapse: false,
      is_btn_disable: false,
      contract_id: -1,
      visible: false,
      canEditContract: false,
      canDeleteContract: false,
      contract: {
        contract: {
          live: {
            product: {
              name: "",
              description: "",
              images: [{ path: null }],
            },
          },
        },
        start_date: "",
        client: {
          name: null,
          email: null,
          cellphone: null,
        },
        history: [
          {
            status: "processing",
            updated_at: "",
          },
        ],
      },
      installments: {}
    }
  },
  filters: {
    date(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  },
  computed: {
    viewSalesUpdate(){
      if(this.contract.status === "canceled" || this.installments.current === this.installments.charges) {
        return true
      }

      return false
    },
    userID() {
      return this.$store.getters.getProfile.id;
    },
    isSeller() {
      return this.$store.getters.isSeller;
    },
    hasSubscriptionId(){
      if((this.contract.history && this.contract.history.length > 0 && this.contract.history[0].subscription_id) || this.contract.subscription_id) {
        return true  
      }
      return false  
    },
    salesPage() {
      const id_produto = this.contract.contract.live?.product?.id;
      const hash_offer = this.contract.contract?.offer?.hash;
      const slug = !!hash_offer ? `${id_produto}/offer/${hash_offer}` : `${id_produto}/`;
      const subscription_id = this.contract?.history[0]?.subscription_id || this.contract?.subscription_id;

      const baseURL = (this.isHeaven ? process.env.VUE_SALES_HEAVEN_PAGE : process.env.VUE_SALES_FAST_PAGE)
      const urlParams = new URLSearchParams();
      urlParams.set('fn', encodeURI(this.contract.client.name));
      urlParams.set('ph', encodeURI(this.contract.client.cellphone));
      urlParams.set('em', encodeURI(this.contract.client.email));
      urlParams.set('document', encodeURI(this.contract.client.document));
      urlParams.set('client_id', this.contract.client_id);
      urlParams.set('subscription_id', subscription_id);
      
      const url = `${baseURL}/assinatura/${slug}?${urlParams.toString()}`
      return url;
    },
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
    paidTransaction() {
      if(this.installments.current > 12) {
        return this.contract?.history.filter(sale => sale.status === 'paid')?.length || 0
      } else return this.installments.current
    }
  },
  methods: {
    getPermissions() {
      if (this.$store.getters.setPanel) {
        var dados = Cookies.get("setPanelPermission");
        if (dados) {
          dados = JSON.parse(dados);
          if (dados.find((x) => x.name === "ContractEdit")) {
            this.canEditContract = true;
          }
          if (dados.find((x) => x.name === "ContractDelete")) {
            this.canDeleteContract = true;
          }
        }
      }
    },
    getMethod(method) {
      return this.textMethod(method)
    },
    formatTel(tel) {
      if (tel) {
        if (tel.toString().indexOf("+55") > -1) {
          var tell = tel.replace(/[() -]/g, "")
          if(tell[0] === '+') { tell = tell.substring(1) }
          return `https://api.whatsapp.com/send?phone=${tell}`;
        } else {
          return `https://api.whatsapp.com/send?phone=55${tel.replace(/[() -]/g, '')}`
        }
      }
    },
    getStatus(status) {
      if (status) {
        switch (status.toLowerCase()) {
          case 'trialing': return { text: this.$t('seller.recurrence_subscriptions.text_2481'), class: 'icon-warning' }
          case 'processing': return { text: this.$t('seller.recurrence_subscriptions.text_2472'), class: 'icon-warning' }
          case 'paid': return { text: this.$t('seller.recurrence_subscriptions.text_2473'), class: this.isHeaven ? 'icon-green heaven' : 'icon-green' }
          case 'pending_payment': return { text: this.$t('seller.recurrence_subscriptions.right_preview.text_1814'), class: 'icon-warning' }
          case 'unpaid': return { text: this.$t('seller.recurrence_subscriptions.text_2457'), class: 'icon-red' }
          case 'canceled': return { text: this.$t('seller.recurrence_subscriptions.text_2458'), class: 'icon-red' }
          case 'ended': return { text: this.$t('seller.recurrence_subscriptions.text_2459'), class: 'icon-red' }
          default: return { text: status, class: 'icon-black' }
        }
      } else return { text: status, class: 'icon-black' }
    },
    getStatus_sales(status) {
      if (status) {
        switch (status.toLowerCase()) {
          case 'processing': return { text: this.$t('seller.recurrence_subscriptions.text_2472'), class: 'is-light-blue' }
          case 'authorized': return { text: this.$t('seller.recurrence_subscriptions.text_2473'), class: 'is-light-blue' }
          case 'paid': return { text: this.$t('seller.recurrence_subscriptions.text_2474'), class: this.isHeaven ? 'is-green heaven' : 'is-green' }
          case 'refunded': return { text: this.$t('seller.recurrence_subscriptions.text_2475'), class: 'is-red' }
          case 'waiting_payment': return { text: this.$t('seller.recurrence_subscriptions.text_2476'), class: 'is-warning' }
          case 'pending_refund': return { text: this.$t('seller.recurrence_subscriptions.text_2477'), class: 'is-warning' }
          case 'refused': return { text: this.$t('seller.recurrence_subscriptions.text_2478'), class: 'is-red' }
          case 'chargedback': return { text: this.$t('seller.recurrence_subscriptions.text_2479'), class: 'is-warning' }
          case 'delayed': return { text: this.$t('seller.recurrence_subscriptions.text_2480'), class: 'is-warning' }
          default: return { text: status, class: 'is-black' }
        }
      } else return { text: status, class: 'is-black' }
    },
    openSalesPage() {
      window.open(this.salesPage);
    },
    resetUrl() {
      if (Object.values(this.$route.query).length) {
        this.$router.push({ query: {} });
      }
      this.updateQueryParams(true); // ao enviar true, a listagem de contratos será atualizada!
    },
    openPanel(contract_id) {
      this.is_btn_disable = false;
      this.visible = true;
      this.contract_id = contract_id;
      this.getPermissions();
      this.fetchContract();
    },
    async cancelContract() {
      let data = {
        id: this.contract.id,
      };

     await service
        .destroy(data)
        .then((response) => {
          if (response.success) {
            this.is_btn_disable = true;

            this.$bvToast.toast(
              this.$t('seller.recurrence_subscriptions.right_preview.text_251'),
              {
                title: "Contrato",
                variant: "info",
                autoHideDelay: 5000,
                appendToast: true,
              }
            );
            EventBus.$emit('relist-contracts');
            this.fetchContract();
          } else {
            this.$bvToast.toast(
              this.$t('seller.recurrence_subscriptions.right_preview.text_252'),
              {
                title: this.$t('seller.recurrence_subscriptions.right_preview.text_1812'),
                variant: "danger",
                autoHideDelay: 5000,
                appendToast: true,
              }
            );
          }
        })
    },
    fetchContract() {
      this.contract = {
        contract: {
          live: {
            product: {
              name: "",
              description: "",
              images: [{ path: null }]
            }
          }
        }
      }
      this.loading = true
      service
        .read({ id: this.contract_id })
        .then(response => { this.contract = response.data, this.installments = response.installments })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
    setColors(coin) {
      if(coin === 'BRL') return "color: #007c5d;"
      if(coin === 'USD') return "color: #e6af0c;"
      if(coin === 'EUR') return "color: #3886f9;"
      if(coin === 'GBP') return "color: #003b36;"
      return "color: #00b07f;"
    },
    validateNextExpiration() {
      if(
        (this.contract.current_period_end ||
        (
          this.contract.history && Array.isArray(this.contract.history) &&
          this.contract.history[this.contract.history.length - 1] &&
          this.contract.history[this.contract.history.length - 1].boleto_expiration_date
        ) ) && this.contract.status !== 'canceled'
      ) return true
      else return false
    },
    textMethod(method) {
      if(method) {
        switch (method.toUpperCase()) {
          case "CREDIT_CARD": return this.$t('views.seller.edit_product.text_1112')
          case "CREDIT-CARD": return this.$t('views.seller.edit_product.text_1112')
          case "BANKTRANSFER": return this.$t('views.seller.edit_product.text_1113')
          case "CREDITCARD": return this.$t('views.seller.edit_product.text_1112')
          case "DEBITCARD": return this.$t('views.seller.edit_product.text_1114')
          case "debitcard": return this.$t('views.seller.edit_product.text_1114')
          case "TWO_CREDIT_CARDS": return this.$t('views.seller.edit_product.text_1115')
          case "DEBITCARD": return "CARTÃO DE DÉBITO"
          case "EFT": return "EFT"
          case "SPEI": return "SPEI"
          case "SENCILLITO": return "SENCILLITO"
          case "OXXO": return "OXXO"
          default: return method
        }
      } else return method;
    },
    checkHasCharges() {
      if (this.contract?.contract?.live?.type === "TRANSACTION"){
        return this.installments.total;
      }

      return this.installments.charges 
        ? this.installments.charges
        : this.$t('seller.recurrence_subscriptions.right_preview.text_3015');
    }
  }
}
</script>

<style lang="scss" scoped>
.panel {
  .sumary {
    font-size: 13px;
  }

  .product-name {
    font-size: 16px;
    font-weight: 600;
    margin: 10px 0;
  }

  .product-image {
    height: 170px;
    overflow: hidden;
    border-radius: 5px;
    background: var(--blue-50);
    display: flex;
    align-items: center;
  }
  .thumb-fake {
    width: 100%;
    color: silver;
    font-size: 32px;
    letter-spacing: 2px;
    justify-content: center;
  }

  .product-description {
    display: block;
    font-size: 14px;
    line-height: 1.5;
    color: var(--gray-200);
    font-weight: normal;
  }
}
.name-product .hash {
  font-size: 12px;
  color: var(--gray-200);
  font-weight: inherit;
}
.container-sidebar {
  padding: 40px;
  padding-top: 20px;
}
.dados-campo {
  font-weight: normal;
  font-size: 13px;
  margin-top: 3px;
}
.item-dados {
  padding: 22px 0;
}
.item-dados + .item-dados {
  border-top: 0.5px solid var(--gray-50);
}
.titulo-item {
  font-size: 18px;
  font-weight: 600;
  color: var(--old-500);
  margin-bottom: 15px;
}
.titulo-item.heaven {
  color: var(--blue-500);
}
.label-campo {
  font-size: 14px;
  font-weight: 600;
  color: var(--old-800);
}
.title-item {
  font-size: 11px;
  color: var(--gray-200);
  display: block;
  font-weight: normal !important;
  margin-bottom: 3px;
}

.label-campo + .label-campo {
  margin-top: 5px;
}
.btn-flex {
  display: flex;
  flex-direction: column;
}
.btn-flex div {
  margin-bottom: 13px;
}
.btn-flex div button {
  width: 100%;
  height: 55px;
}
.btn-flex div button:hover {
  transform: none;
}

// collapse
.titulo-arrow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}
.titulo-arrow.ativo {
  margin-bottom: 15px;
}
.titulo-arrow.ativo img {
  transition: 0.3s;
  transform: rotate(180deg);
}

// history
.titulo-collapse {
  font-size: 13px !important;
}

.history-item {
  padding: 15px 0;
  position: relative;
}
.history-item::before {
  left: -10px;
  top: 50%;
}

.history-item + .history-item {
  border-top: 1px solid var(--gray-50);
}
.sem-historico {
  margin-top: 20px;
  font-size: 14px;
  color: var(--gray-200);
}
.whats-cliente {
  font-size: 14px;
  color: var(--blue-500);
}
.whats-cliente svg {
  margin-left: 5px;
}

.product-main {
  display: grid;
  grid-template-columns: 0.5fr 3fr;
  gap: 20px;
  align-items: center;
}
.img-product {
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-product,
.img-product img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--gray-50);
  object-fit: cover;
}
.name-product span {
  font-size: 11px;
  color: var(--gray-200);
}
.name-product p {
  font-weight: 600;
}
.chip {
  width: 30px;
  height: 30px;
  font-size: 15px;
  font-weight: 700;
  border:  1px solid transparent;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}
</style>
